import { Life } from 'interfaces/life'
import { Dispatch } from 'redux'
import { Action } from '../actions/lifeActions'
import { PaginatedModel } from 'interfaces/pagination'
import { LifeActionType } from 'state/action-types/lifeTypes'

export const paginateLives = (data: PaginatedModel<Life>) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: LifeActionType.PAGINATE_LIVES,
            payload: data
        })
    }
}